<div *ngIf="defaultDeviceCatalog">
  <div class="card p-0 pt-4 mb-0">
    <div class="flex flex-column mx-4 mb-3">
      <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between mb-3">
        <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
          {{'model.defaultDevice' | transloco}} {{defaultDeviceCatalog.name}} ({{'attribute.versionMin' | transloco}} {{defaultDeviceCatalog.version}})
        </p>
        <div class="flex-order-0 sm:flex-order-1">
          <button
            [label]="'common.edit' | transloco"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            routerLink="../edit"
            icon="pi pi-pencil"
          ></button>
        </div>
      </div>
      <div>
        <p *ngIf="defaultDeviceCatalog.description"><b>{{'attribute.description' | transloco}}: </b>{{defaultDeviceCatalog.description}}</p>
        <p *ngIf="!defaultDeviceCatalog.description" class="font-italic">{{'empty.description' | transloco}}</p>
      </div>
    </div>
    <div>
      <p-tabMenu
        #tab
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tab)"
        class="hidden xl:inline"
      ></p-tabMenu>
      <p-tabMenu
        #tabIcon
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tabIcon)"
        class="xl:hidden"
      >
        <ng-template pTemplate="item" let-item let-i="index">
          <i [className]="item.icon"></i>
        </ng-template>
      </p-tabMenu>
    </div>
  </div>
  <div class="with-margin">
    <app-default-device-overview [defaultDeviceCatalog]="defaultDeviceCatalog" *ngIf="activeItem.id == 'overview'"></app-default-device-overview>
    <app-default-device-sensors [defaultDeviceCatalog]="defaultDeviceCatalog" *ngIf="activeItem.id == 'sensors'"></app-default-device-sensors>
    <app-default-device-properties [defaultDeviceCatalog]="defaultDeviceCatalog" *ngIf="activeItem.id == 'properties'"></app-default-device-properties>
    <app-default-device-integration-modules [defaultDeviceCatalog]="defaultDeviceCatalog" *ngIf="activeItem.id == 'integrationModules'"></app-default-device-integration-modules>
  </div>
</div>
